/* eslint-disable sonarjs/cognitive-complexity */
import {
  BaSeContainer,
  BaSeDialogContext,
  BaSeIcon,
  BaSeParagraph,
  BaSeSmall1,
  BaSeSmall2,
  BaSeTheme,
  BaSeTooltip,
} from '@base/react';
import * as React from 'react';
import { useInterviewController } from '../../../../hooks/controllers/interview-controller';
import {
  BoxTag,
  ColumnEmailDates,
  HorizonAlign,
  HorizontalAlign,
  PreviousEmailsWrapper,
  TextLink,
  VerticalAlign,
} from './data-table-styled';

import ShowToltipRegistration from './show-toltip-registration';

export const EmailDate = ({ props }) => {
  const { showModal } = React.useContext(BaSeDialogContext);
  const { getInterviewEmailDates } = useInterviewController();
  const [data, setData] = React.useState({});
  const [tooltipOpen, setTooltipOpen] = React.useState(false);

  React.useEffect(() => {
    if (props.sendingRegistrationEmail) {
      setData(getInterviewEmailDates(props));
    }
  }, [getInterviewEmailDates, props]);

  const showDialogPreviousEmails = React.useCallback(
    (historyEmailDates) => {
      return showModal({
        actions: [],
        alignActions: 'center',
        size: 'small',
        title: 'Status anteriores',
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: () => (
          <PreviousEmailsWrapper>
            <ColumnEmailDates>
              <BaSeParagraph
                isBold
                color={BaSeTheme.colors.institucionais.cinzaSebrae30}
              >
                Enviados
              </BaSeParagraph>
              {historyEmailDates.map((history, index) => (
                <BaSeSmall1
                  key={index}
                  color={BaSeTheme.colors.institucionais.cinzaSebrae60}
                >
                  {history.sendEmailDate}
                </BaSeSmall1>
              ))}
            </ColumnEmailDates>
            <ColumnEmailDates>
              <BaSeParagraph
                isBold
                color={BaSeTheme.colors.institucionais.cinzaSebrae30}
              >
                Abertos
              </BaSeParagraph>
              {historyEmailDates.map((history, index) => (
                <BaSeSmall1
                  key={index}
                  color={BaSeTheme.colors.institucionais.cinzaSebrae60}
                >
                  {history.openedEmailDate}
                </BaSeSmall1>
              ))}
            </ColumnEmailDates>
          </PreviousEmailsWrapper>
        ),
      });
    },
    [showModal],
  );

  if (!props.sendingRegistrationEmail) {
    return (
      <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
        Não enviado
      </BaSeSmall1>
    );
  }

  return (
    <BaSeContainer>
      <HorizontalAlign>
        <VerticalAlign>
          {data.emailDates && (
            <React.Fragment>
              <HorizonAlign>
                <BaSeSmall1
                  color={BaSeTheme.colors.institucionais.cinzaSebrae60}
                >
                  {data.emailDates.sendEmailDate}
                </BaSeSmall1>

                {data?.showUnfilledUnfinishedMark && (
                  <BoxTag
                    onMouseEnter={() => setTooltipOpen(true)}
                    onMouseLeave={() => setTooltipOpen(false)}
                  >
                    <BaSeIcon
                      color={BaSeTheme.colors.feedbackInterface.sucesso26}
                      description="Sólido"
                      name="check-double"
                      size={24}
                    />
                    <BaSeTooltip
                      color={BaSeTheme.colors.institucionais.cinzaSebrae60}
                      direction="top"
                      coordinates={{ bottom: '34px' }}
                      message={data?.messageUnfilledUnfinished}
                      width={400}
                      open={tooltipOpen}
                    />
                  </BoxTag>
                )}
              </HorizonAlign>
              <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
                {data.emailDates.openedEmailDate}
              </BaSeSmall1>
            </React.Fragment>
          )}

          {data.historyEmailDates?.length > 0 && (
            <TextLink>
              <BaSeSmall2
                color={BaSeTheme.colors.institucionais.azulSebrae20}
                onClick={() => showDialogPreviousEmails(data.historyEmailDates)}
              >
                Status anteriores
              </BaSeSmall2>
            </TextLink>
          )}
        </VerticalAlign>
        <ShowToltipRegistration data={props} />
      </HorizontalAlign>
    </BaSeContainer>
  );
};
